import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import styles from './Term.module.scss';

const cx = classNames.bind(styles);

const Term = forwardRef(({ label, value, unit = '', onClick, children }, ref) => {
  let displayValue = '-';
  if (value) {
    if (React.isValidElement(value)) {
      displayValue = value;
    } else {
      displayValue = `${value}${unit}`;
    }
  }

  return (
    <div ref={ref} className={cx('container', { pointer: !!onClick })} onClick={onClick}>
      <div className={cx('label')}>{label}</div>
      <div className={cx('value')}>{displayValue}</div>
      {children}
    </div>
  );
});

Term.displayName = 'Term';

Term.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  unit: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default Term;
